/* eslint-disable @typescript-eslint/no-explicit-any */
import { useApolloClient } from '@apollo/client'
import {
  Button,
  Card,
  FormControlLabel,
  Switch,
  TextField,
  Typography
} from '@material-ui/core'
import React, { ChangeEvent, useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  REMOVE_ANATOMY_EYE_CUSTOMIZATIONS,
  UPDATE_ANATOMY_EYE_TYPE
} from '../../graphql/queries'
import { useGlobalState } from '../../providers/GlobalState'
import { AnatomyEye } from '../../types/graphql'
import { SuccessButton, WarningButton } from '../Buttons'
import { ButtonBox } from '../Help/HelpLayout'
import { useAnatomyEyeForm } from './useAnatomyEyeForm'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 90%;
  overflow: auto;
`
const EyeAnatomyEdit = (): JSX.Element => {
  const { anatomyEye, refetch } = useGlobalState()
  const client = useApolloClient()
  const [loading, setLoading] = useState(false)

  const { data, setData, reset, setIsEditing } = useAnatomyEyeForm()

  useEffect(() => {
    setIsEditing(true)
    setData(anatomyEye as AnatomyEye)
    return () => {
      reset()
    }
  }, [anatomyEye])

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value, name } = e.currentTarget

    setData({ ...data, [name]: value })
  }

  const handleCancel = () => {
    setData(anatomyEye as AnatomyEye)
  }

  const handleRemove = () => {
    setLoading(true)
    client
      .mutate({
        mutation: REMOVE_ANATOMY_EYE_CUSTOMIZATIONS,
        variables: {
          id: data.id
        }
      })
      .then(() => {
        refetch?.()
        setLoading(false)
      })
  }

  const handleSave = () => {
    setLoading(true)
    const id = data.id
    client
      .mutate({
        mutation: UPDATE_ANATOMY_EYE_TYPE,
        variables: {
          id,
          input: {
            name: data.name,
            enable: data.enable,
            internalAnnotations: data.internalAnnotations
          }
        }
      })
      .then(() => {
        refetch?.()
        setLoading(false)
      })
  }

  return (
    <Card
      style={{
        position: 'absolute',
        width: 'calc(75% - 20px)',
        background: 'rgba(255,255,255,0.80)',
        height: 'calc(90% - 200px)',
        padding: '16px 16px',
        overflowY: 'auto',
        borderRadius: 4,
        zIndex: 20,
        top: 100,
        left: '50%',
        transform: 'translate(-50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      }}
    >
      <Content>
        <Typography variant="h4">Edição de {data?.name}</Typography>
        <br />
        <TextField
          type="text"
          name="name"
          value={`${data?.name}`}
          variant="outlined"
          label="Nome Técnico"
          fullWidth
          onChange={handleChange}
        />
        <br />
        <FormControlLabel
          control={
            <Switch
              checked={data.enable}
              name="enable"
              color="primary"
              onChange={(e, checked) =>
                handleChange({
                  currentTarget: { value: checked, name: 'enable' }
                } as any)
              }
            />
          }
          label="Ativo a exibição para pacientes"
        />
        <br />
        <TextField
          name="internalAnnotations"
          onChange={handleChange}
          value={data?.internalAnnotations || ''}
          label="Anotações internas"
          variant="outlined"
          helperText="Esse campo é apenas de anotações internas, não será exibido no APP"
          multiline
          fullWidth
          rows={2}
        />
        <br />
      </Content>
      <ButtonBox
        style={{
          paddingTop: 20
        }}
      >
        <Button
          color="primary"
          onClick={handleRemove}
          variant="contained"
          disabled={loading}
        >
          {loading ? 'Aguarde...' : 'Valor Padrão'}
        </Button>
        <WarningButton variant="contained" onClick={handleCancel}>
          Cancelar
        </WarningButton>
        <SuccessButton
          disabled={loading}
          variant="contained"
          onClick={handleSave}
        >
          {loading ? 'Aguarde...' : 'Salvar'}
        </SuccessButton>
      </ButtonBox>
    </Card>
  )
}

export default EyeAnatomyEdit
